export const customCategoriesSelector = (state) => state.customCategories?.customCategories;
export const customcategorySelector = (state) => state.customCategories?.customCategory;
export const loadingCustomCategoriesSelector = (state) => state.customCategories?.loading;
export const customCategoriesValuesSelector = (state) => state.customCategories?.customCategoriesValues;
